<template>
  <div id="zaddress">
    <ul>
      <li class="relativeItem" v-for="(n,index) in 12" :key="index">
        <a href="#" class="allA"></a>
        <p class="p1 flex-box relativeItem">
          <span class="name">东渡扶桑</span>
          <span class="bold">159****7120</span>
          <span class="detip">默认</span>
        </p>
        <p class="p2">重庆市渝中区解放碑国际大道海航保利大厦43楼1-18</p>
        <img class="edit absoluteItem centerY" src="../../assets/zshop/add(1).png" @click="edit">
        <img class="defult absoluteItem" src="../../assets/zshop/add(2).png" >
      </li>
    </ul>

    <!--添加地址按钮-->
    <button class="add-b">新增收货地址</button>

  </div>
</template>

<script>
// import city from "../../utils/scity";

export default {
  name: "zaddress",
  components: {},
  data() {
    return {
    };
  },
  methods: {
    /**编辑收货地址 */
    edit(){
      this.$router.push({path:"/zadda"})
    }
  },
  mounted: function() {
    this.$tool.setTitle("收货地址");
  },
  watch: {}
};
</script>








<style scoped>
.allA{
  z-index: 1;
}
.defult{
  top: 0;
  left: 0;
  width: 22px;
}
.edit{z-index: 2;
width: 18px;
right: 16px;}
ul{
  margin-bottom: 5rem;
}
li{
  padding: 13px 16px;
  background: white;
  margin-bottom: 4px;
}
.p1{
  font-size: 16px;
  align-items: center;
}
.p1 span{
  margin-right: 7px;
  margin-bottom: 6px;
}
.bold{
  font-weight: bold; 
}
.detip{
  font-size: 10px;
  color: white;
  border-radius: 3px;
  background: #FF6161;
  padding: 0 4px;
}
.p2{
  max-width: 80%;
  text-align: justify;
  font-size: 12px;
}

.add-b{
  position: fixed;
  z-index: 3;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 13px;
  text-align: center;
  width: 90%;
  padding: 10px 0;
  border-radius: 3rem;
  background: #A816FF;
  color: white;
}
</style>
